import { Box, Divider, FormControl, MenuItem, OutlinedInput, Select, SelectChangeEvent, Tooltip } from "@mui/material";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import * as React from 'react';
import { editGrnRowsData } from "../../types/types";
import { truncateToTwoDecimals } from "../../components/dms_common/DmsUtils";
import { TruncatedTextUptoLine } from "../../components/dms_common/DmsUtils";
import { ReactComponent as CircledRight } from "../../assets/image/svg/circledRight.svg";

export const getEditGrnConfig = (selectedRejectionReasons: any, handleRejectionReasonChange: (row: any, event: SelectChangeEvent<typeof selectedRejectionReasons>) => void, handleEditAcceptedQuantity: (paramRow: any, value: any, changedQuantity: any, quantityType: string) => void, toggleTaxInfoCollapsedStatus: (
  paramRow: editGrnRowsData,
  collapsed: boolean,
) => void,rejectionReasonsArraySkuLevel: { id: string; label: string }[], handlePromotionModalVisibility: (paramRow: editGrnRowsData) => void,
showPricePerPiece: boolean,
  showTaxPercentage: boolean = true
  ) => {
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const { packUnitLabelPrimary,caseUnitLabelPrimary,otherUnitLabelPrimary,currency,batchIdConfiguration } = ConfigDictionary;
  return [
    {
        headerName: "skuNameAndCode",
        mappedValue: "batchCode",
        width: 220,
        renderHeader: (value: any) => (
          <Box display="flex" sx={{ flexDirection: "column", alignItems: "left" }}>
                    <Box display="flex" flexDirection="column" sx={{ textAlign: "left" }}>
                      <span>{"SKU Name"}</span>
                      <span className="customTableInfo_marginTopNegative">{"& Code"}</span>
                    </Box>
                  </Box>
        ),
        renderCell: (value: any, row: any) => {
          return (
            <Tooltip title={`${row?.skuDescription} - ${value}`}>
              <Box className="sku_name_truncate_text ViewOrderConfig_skuCode">
                {row?.freeItem && (
                  <span className="ViewOrderConfig_freeText">FREE</span>
                )}
                <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                  <span style={{ ...TruncatedTextUptoLine(1), fontWeight: 500, fontSize: "13px" }}>
                    {row?.skuDescription}
                  </span>
                  <span style={{ ...TruncatedTextUptoLine(1), fontSize: "12px", color: "#666" }}>
                    {value}
                  </span>
                </div>
              </Box>
            </Tooltip>
          );
        },
      },
    ...( batchIdConfiguration) ? [
        {
          headerName: "Batch Id",
          mappedValue: "batchId",
          width: 100,
          renderHeader: (value: any) => (
            <Box display={"flex"} flexDirection={"column"}>
              <span>{"Batch ID"}</span>
            </Box>
          ),
          renderCell: (value: any, row: any) => {
              return (
                <Tooltip title={value}>
                  <Box className="sku_name_truncate_text">
                    <span style={TruncatedTextUptoLine(2)}>{value ?? "-"}</span>
                  </Box>
                </Tooltip>
              );
            },
        }
      ] : [],
      {
      headerName: "Promotion",
      mappedValue: "promotion",
      width: 130,
      renderCell: (value: any, row: any) => {
        if (+row?.discount === 0) return <>-</>;
        return (
          <div
            className="view-discounts-container"
            onClick={() => handlePromotionModalVisibility(row)}
          >
            <span>View Promos</span>
            <CircledRight style={{ width: "10px" }} />
          </div>
        );
      },
    },

    ...(caseUnitLabelPrimary
      ? [
          {
            headerName: "Cases",
            mappedValue: "initialCaseQuantity",
            width: 60,
            textAlign: "center",
            renderHeader: () => (
              <Box display="flex" sx={{ flexDirection: "column", alignItems: "center" }}>
                <Box display="flex" flexDirection="column" sx={{ textAlign: "left" }}>
                  <span>{"Qty"}</span>
                  <span>{`(${caseUnitLabelPrimary})`}</span>
                </Box>
              </Box>
            ),
            renderCell: (value: any) => (
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <div className="view_order_pack_quantity_input style_adjust">{value}</div>
              </Box>
            ),
          },
        ]
      : []),
    ...(otherUnitLabelPrimary
      ? [
          {
            headerName: "Others",
            mappedValue: "initialOtherUnitQuantity",
            width: 60,
            textAlign: "center",
            renderHeader: () => (
              <Box display="flex" sx={{ flexDirection: "column", alignItems: "center" }}>
                <Box display="flex" flexDirection="column" sx={{ textAlign: "left" }}>
                  <span>{"Qty"}</span>
                  <span>{`(${otherUnitLabelPrimary?.slice(0, 3)})`}</span>
                </Box>
              </Box>
            ),
            renderCell: (value: any) => (
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <div className="view_order_pack_quantity_input style_adjust">{value}</div>
              </Box>
            ),
          },
        ]
      : []),
    ...(packUnitLabelPrimary
      ? [
          {
            headerName: "Pieces",
            mappedValue: "initialPieceQuantity",
            width: 60,
            textAlign: "center",
            renderHeader: () => (
              <Box display="flex" sx={{ flexDirection: "column", alignItems: "center" }}>
                <Box display="flex" flexDirection="column" sx={{ textAlign: "left" }}>
                  <span>{"Qty"}</span>
                  <span>{`(${packUnitLabelPrimary})`}</span>
                </Box>
              </Box>
            ),
            renderCell: (value: any) => (
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <div className="view_order_pack_quantity_input style_adjust">{value}</div>
              </Box>
            ),
          },
        ]
      : []),

    {
      headerName: "Price (Each Cs)", mappedValue: "pricePerCase", width: 100,      currencySymbol: currency,
      renderHeader: (value: any) => (
        <Box
          display={"flex"}
          sx={{ flexDirection: "column", alignItems: "left" }}
        >
          <Box
            display={"flex"}
            flexDirection={"column"}
            sx={{ textAlign: "left" }}
          >
            <span>{"Price"}</span>
            <span>{"(Each Cs)"}</span>
          </Box>
        </Box>
      ),
    },


    ...(showPricePerPiece
      ? [
    {
      headerName: "Price (Each Pc)",
      mappedValue: "piecePrice",
      width: 100,
      textAlign: "left",
      currencySymbol: currency,
      renderHeader: (value: any) => (
        <Box
          display={"flex"}
          sx={{ flexDirection: "column", alignItems: "left" }}
        >
          <Box
            display={"flex"}
            flexDirection={"column"}
            sx={{ textAlign: "left" }}
          >
            <span>{"Price"}</span>
            <span>{"(Each Pc)"}</span>
          </Box>
        </Box>
      ),
    },
    ]
  : []),


    { headerName: "Amount", mappedValue: "actualAmount", width: 100  ,     currencySymbol: currency},
    { headerName: "Discount", mappedValue: "discount", width: 90 ,      currencySymbol: currency,},
    
    {
      headerName: "Tax Amount & (%)",
      mappedValue: "taxInfo",
      width: 150,
      textAlign: "left",
      renderHeader: (value: any) => (
        <Box
          display={"flex"}
          sx={{ flexDirection: "column", alignItems: "left" }}
        >
          <Box
            display={"flex"}
            flexDirection={"column"}
            sx={{ textAlign: "left" }}
          >
            <span>{"Tax"}</span>
            <span>{`Amount ${showTaxPercentage ? "& (%)" : ""}`}</span>
          </Box>
        </Box>
      ),
      renderCell: (value: any, row: any) => {
        const isCollapsed = row.collapsed;

        const aggregateTaxAmount = value?.reduce((acc:any,curr:any)=>{
          acc += Number(curr?.taxAmount)
          return acc
        },0)
        
        const aggregateTaxPercent = value?.reduce((acc:any,curr:any)=>{
          acc += Number(curr?.taxPercent)
          return acc
        },0)

        const consolidatedTaxObj = {taxType:"All", taxAmount:aggregateTaxAmount, taxPercent:aggregateTaxPercent ,};

        return (
          <FormControl className="manage_order_filter">
          <Select
            labelId="dropdown_label"
            size="small"
            displayEmpty
            sx={{
              "& .MuiSelect-select": {
                padding: "0px !important",
              },
              width: "100%",
              fontSize: "14px",
              padding: "0px",
              "&.Mui-focused": {
                boxShadow: "none",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
              },
              
              "& .MuiSelect-icon": {
                display: value.length === 0 ? "none" : "block",
                marginRight: "-11px" 
              },
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  mt: 1,
                  padding: 0,
                  boxShadow: "none",
                  border: "1px solid #DEDEDE",
                  borderRadius: "8px",
                },
              },
              MenuListProps: {
                sx: {
                  padding: "7px 0",
                },
              },
            }}
            renderValue={() => {
              return (
                <span style={{ color: "#7c7c7c", fontSize: "13px" }}>
                  <span>
                    {`${consolidatedTaxObj?.taxType ?? ""}: ${
                      currency ?? ""
                    }\u200A${truncateToTwoDecimals(consolidatedTaxObj?.taxAmount ?? 0)}`}
                    {showTaxPercentage && `(${consolidatedTaxObj?.taxPercent ?? 0}%)`}
                  </span>
                </span>
              );
            }}
          >
            
            {value.length > 0 && value.map((item: any, index: any, arr: any) => (
              <MenuItem
                key={item?.taxType}
                value={item?.taxType}
                className="menuItem-test-debug"
                sx={{
                  padding: "2px 0px",
                  borderBottom:
                    index !== arr.length - 1
                      ? "1.5px dashed #EBEBEB"
                      : "none",
                  margin: "0 10px",
                  pointerEvents: "none"
                }}
              >
                <div className="loadout_dropdown_menu_item">
                  <span>
                    {`${item?.taxType ?? ""}: ${currency ?? ""}${truncateToTwoDecimals(
                      item?.taxAmount ?? 0
                    )}`}
                    {showTaxPercentage && `(${item?.taxPercent ?? 0}%)`}
                  </span>
                </div>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        
        );
      },
    },
     ...(caseUnitLabelPrimary
      ? [
    {
      headerName: "Accepted Qty (Cs)",
      mappedValue: "accpeptedQtyObj",
      renderHeader: (value: any) => (
        <Box>
          <span>{value}</span>
          <BorderColorIcon style={{ color: "#17B4A3", fontSize: "13px" }} />
        </Box>
      ),
      renderCell: (value: any, row: any) => {
        return (
          <Box sx={{ border: "1px solid #DFE2E7", borderRadius: "4px", width: "2.5rem" }}>
            <input
              style={{
                width: "100%", border: "none", outline: "none", padding: "0 2px", boxSizing: "border-box",
                background: "transparent", textAlign: "center",
              }}
              value={value?.acceptedQty}
              onChange={(e) => {
                if ( e.target.value === "" ||   (!isNaN(Number(e.target.value)) && (/^\d+$/).test(e.target.value) )) {
                  handleEditAcceptedQuantity(row, value, e.target.value,caseUnitLabelPrimary)
                }
              }}
            />
            <Divider
              style={{
                width: "80%",
                borderColor: "#DFE2E7",
                borderWidth: "1px 0 0 0",
                padding: "1px",
                boxSizing: "border-box",
                marginLeft: 'auto',
                marginRight: 'auto',
              }}
            />
          </Box>
        );
      },
      width: 100,
    },
    {
      headerName: "Rejected Qty (Cs)",
      mappedValue: "rejectedQtyObj",
      renderCell: (value: any) => {
        return (
          <Box sx={{ border: "1px solid #DFE2E7", borderRadius: "4px", width: "2.5rem" }}>
            <div
              style={{ width: "100%", border: "none", outline: "none", padding: "1px 3px 3px 3px", textAlign: "center" }}
            >
              {value?.rejectedQty.toString()}
            </div>
          </Box >
        );
      },
      width: 100,
    },
            ]
    : []),


    // other
    ...(otherUnitLabelPrimary
      ? [
    {
      headerName: `Accepted Qty (${otherUnitLabelPrimary})`,
      mappedValue: "accpeptedOtherQtyObj",
      renderHeader: (value: any) => (
        <Box>
          <span>{value}</span>
          <BorderColorIcon style={{ color: "#17B4A3", fontSize: "13px" }} />
        </Box>
      ),
      renderCell: (value: any, row: any) => {
        return (
          <Box sx={{ border: "1px solid #DFE2E7", borderRadius: "4px", width: "2.5rem" }}>
            <input
              style={{
                width: "100%", border: "none", outline: "none", padding: "0 2px", boxSizing: "border-box",
                background: "transparent", textAlign: "center",
              }}
              value={value?.acceptedQty}
              onChange={(e) => {
                if ( e.target.value === "" ||   (!isNaN(Number(e.target.value)) && (/^\d+$/).test(e.target.value) )) {
                  handleEditAcceptedQuantity(row, value, e.target.value,otherUnitLabelPrimary)
                }
              }}
            />
            <Divider
              style={{
                width: "80%",
                borderColor: "#DFE2E7",
                borderWidth: "1px 0 0 0",
                padding: "1px",
                boxSizing: "border-box",
                marginLeft: 'auto',
                marginRight: 'auto',
              }}
            />
          </Box>
        );
      },
      width: 100,
    },
    {
      headerName: `Rejected Qty  (${otherUnitLabelPrimary})`,
      mappedValue: "rejectedOtherQtyObj",
      renderCell: (value: any) => {
        return (
          <Box sx={{ border: "1px solid #DFE2E7", borderRadius: "4px", width: "2.5rem" }}>
            <div
              style={{ width: "100%", border: "none", outline: "none", padding: "1px 3px 3px 3px", textAlign: "center" }}
            >
              {value?.rejectedQty.toString()}
            </div>
          </Box >
        );
      },
      width: 100,
    },
            ]
    : []),


    // piece

    ...(packUnitLabelPrimary
      ? [
    {
      headerName: "Accepted Qty (Pc)",
      mappedValue: "accpeptedPieceQtyObj",
      renderHeader: (value: any) => (
        <Box>
          <span>{value}</span>
          <BorderColorIcon style={{ color: "#17B4A3", fontSize: "13px" }} />
        </Box>
      ),
      renderCell: (value: any, row: any) => {
        return (
          <Box sx={{ border: "1px solid #DFE2E7", borderRadius: "4px", width: "2.5rem" }}>
            <input
              style={{
                width: "100%", border: "none", outline: "none", padding: "0 2px", boxSizing: "border-box",
                background: "transparent", textAlign: "center",
              }}
              value={value?.acceptedQty}
              onChange={(e) => {
                if ( e.target.value === "" ||   (!isNaN(Number(e.target.value)) && (/^\d+$/).test(e.target.value) )) {
                  handleEditAcceptedQuantity(row, value, e.target.value,packUnitLabelPrimary)
                }
              }}
            />
            <Divider
              style={{
                width: "80%",
                borderColor: "#DFE2E7",
                borderWidth: "1px 0 0 0",
                padding: "1px",
                boxSizing: "border-box",
                marginLeft: 'auto',
                marginRight: 'auto',
              }}
            />
          </Box>
        );
      },
      width: 100,
    },
    {
      headerName: "Rejected Qty (Pc)",
      mappedValue: "rejectedPieceQtyObj",
      renderCell: (value: any) => {
        return (
          <Box sx={{ border: "1px solid #DFE2E7", borderRadius: "4px", width: "2.5rem" }}>
            <div
              style={{ width: "100%", border: "none", outline: "none", padding: "1px 3px 3px 3px", textAlign: "center" }}
            >
              {value?.rejectedQty.toString()}
            </div>
          </Box >
        );
      },
      width: 100,
    },
            ]
    : []),


    {
      headerName: "Final Amount",
      mappedValue: "finalAmount",
      width: 100,
      textAlign: "left",
      currencySymbol: currency,
      renderHeader: (value: any) => (
        <Box
          display={"flex"}
          sx={{ flexDirection: "column", alignItems: "left" }}
        >
          <Box
            display={"flex"}
            flexDirection={"column"}
            sx={{ textAlign: "left" }}
          >
            <span>{"Final"}</span>
            <span>{"Amount"}</span>
          </Box>
        </Box>
      ),
      renderCell: (value: any) => (
        <Box>
          <span
            style={{
              textAlign: "left",
              fontWeight: 600,
            }}
          >
            {`${currency}\u200A${value ?? ""}`}
          </span>
        </Box>
      )
    },
  
    {
      headerName: "Rejection Reason",
      mappedValue: "skuRejectionReason",
      renderCell: (value: any, row: any) => {
        // Check if the accepted quantity is less than the total quantity
        const isAcceptedQtyChanged = (row.accpeptedQtyObj?.acceptedQty < row.accpeptedQtyObj?.totalQty) ||
        (row.accpeptedPieceQtyObj?.acceptedQty < row.accpeptedPieceQtyObj?.totalQty) ||
        (row.accpeptedOtherQtyObj?.acceptedQty < row.accpeptedOtherQtyObj?.totalQty);
        return (
          <div>
            <FormControl variant="outlined" disabled={!isAcceptedQtyChanged}>
              <Select
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                value={value ?? ""}
                onChange={e => { handleRejectionReasonChange(row, e) }}
                size="small"
                displayEmpty
                input={<OutlinedInput />}
                className="edit_grn_checkbox"
                sx={{ padding: '1px 0px 2px' }}
                renderValue={(selected) => {
                  if (!isAcceptedQtyChanged || !selected) {
                    return <span>Select Reason</span>;
                  }
                  return selected;
                }}
              >
                {rejectionReasonsArraySkuLevel.map((reason) => (
                  <MenuItem key={reason.id} value={reason.label} sx={{ fontSize: '13px' }}>
                    {reason.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        );
      },
      width: 155,
    }
    
  ];
}
const getQuantityLabels = () => {
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const { packUnitLabelPrimary,caseUnitLabelPrimary,otherUnitLabelPrimary } = ConfigDictionary;

    
  const labels: string[] = [
    caseUnitLabelPrimary ? `${caseUnitLabelPrimary}` : "",
    otherUnitLabelPrimary ? `${otherUnitLabelPrimary}` : "",
    packUnitLabelPrimary ? `${packUnitLabelPrimary}` : ""
  ].filter(Boolean); // Removes empty strings
  
    return labels.length > 0 ? `Qty (${labels.join(", ")})` : "Qty";
  };
export const getMetaData1 = (currencySymbol: string): any[] => [
  {
    keys: "totalCasePieceOtherQuantity",
    label: getQuantityLabels(),
    index: 1,
    valueType: "String",
  },
  {
    keys: "totalQuantity",
    label: "Total Products",
    index: 2,
    valueType: "Number",
  },
  {
    keys: "initialAmount",
    label: "Total Amount",
    index: 3,
    valueType: "Number",
    currencySymbol: currencySymbol,
  },
  {
    keys: "discountValue",
    label: "Discount Value",
    index: 4,
    valueType: "Number",
    currencySymbol: currencySymbol,
  },
  {
    keys: "taxAmount",
    label: "Tax Amount",
    index: 5,
    valueType: "Number",
    currencySymbol: currencySymbol,
  },
  {
    keys: "netAmount",
    label: "Final Amount",
    index: 6,
    valueType: "Number",
    currencySymbol: currencySymbol,
    focusField: true,
  },
];

export const metaData2: any[] = [
  {
    keys: "supplierCode",
    label: "Supplier Code",
    index: 1,
    removeEllipsis: true,
    truncateTextAfterChar: 43,
  },
  {
    keys: "supplierName",
    label: "Supplier Name",
    index: 2,
    removeEllipsis: true,
    truncateTextAfterChar: 43,
  },
  {
    keys: "deliveryDate",
    label: "Est. Delivery Date",
    index: 3,
    removeEllipsis: true,
  },
];


